
import './LoadingAnimation.css'
const Skeletonpage = () => {

    return <div className="loading-animation">
    <div className="spinner"></div>
  </div>

}

  

export default Skeletonpage;
